import {UPDATE_PREFERENCES} from './preferences'
import {ADD_MESSAGE} from './preferences'
import {ADMIN_SETTINGS} from './preferences'
import {PORTRAIT_SETTINGS} from './preferences'
import {CREATE_CONTENT} from './preferences'
import {SET_LOGIN} from './preferences'
import {SET_CONVERSATION} from './preferences'
import {SET_MESSAGES_BY_LANGUAGE} from './preferences'
import {SET_CONVERSATION_MESSAGES} from './preferences'
import {SET_GROUP_LIST} from './preferences'
import {SET_GROUP} from './preferences'
import { combineReducers } from 'redux'
import initialState from './communityServices'
import adminInitialState from './adminServices_en'
import portraitState from './portraitServices.en'
import messages from './importantMessages.en'
import conversations from './chatMessages.en'
import groups from './groups.en'
import content from './contentNewPage'
import userDetails from './userDetails'


const userPreferences = (state = initialState, action) => {
//  console.log("call to reducer userPreferences");
  switch (action.type) {
    case UPDATE_PREFERENCES:
      state = action.payload.state;
      return [
        ...state,
      ]
    default:
      return state
  }
}

const adminSettings = (state = adminInitialState, action) => {
//  console.log("call to reducer adminSettings");
  switch (action.type) {
    case ADMIN_SETTINGS:
      state = action.payload.state;
      return [
        ...state,
      ]
    default:
      return state
  }
}

const portraitSettings = (state = portraitState, action) => {
//  console.log("call to reducer portraitSettings");
  switch (action.type) {
    case PORTRAIT_SETTINGS:
      state = action.payload.state;
      return [
        ...state,
      ]
    default:
      return state
  }
}

const importantMessages = (state = messages, action) => {
//  console.log("call to reducer importantMessages ");
  switch (action.type) {
    case ADD_MESSAGE:
      state = action.payload.state;
      return {
        ...state,
        arr: state.unshift(action.payload.newItem)
      }
    case SET_MESSAGES_BY_LANGUAGE:
      state = action.payload.state;
       return [...state];
    default:
      return state
  }
}

const newPageContent = (state = content, action) => {
//  console.log("call to reducer newPageContent");
  switch (action.type) {
    case CREATE_CONTENT:
      state = action.payload.state;
      return state;
    default:
      return state
  }
}

const activeConversationState = (state = null , action) => {
  let newState = {...state};
 // console.log(state);
  switch (action.type) {
    case SET_CONVERSATION:
      newState.id = action.payload.state.id;
      newState.name = "pluto";
      state = newState;
      return newState;

    default:
      return state
  }
}

const conversationMessages = (state = conversations , action) => {

 // console.log(state);
  switch (action.type) {
    case SET_CONVERSATION_MESSAGES:
      state = action.payload.state;
      return [...state];
    default:
      return state
  }
}


const loginSettings = (state = userDetails, action) => {
  //  console.log("call to reducer newPageContent");
    switch (action.type) {
      case SET_LOGIN:
        let newstate = action.payload.state;
        state.name = newstate.name;
        state.group = newstate.group;
        return  newstate;
      default:
        return state
    }
  }

  const groupList = (state = groups, action) => {
       console.log(state);
      switch (action.type) {
        case SET_GROUP_LIST:
          state = action.payload.state;
          return [...state];
        default:
          return state
      }
  }
  
  const activeGroup = (state = null , action) => {
    console.log(state);
   switch (action.type) {
     case SET_GROUP:
       state = action.payload.state;
       return state;
     default:
       return state
   }
}

const rootReducer = combineReducers({loginSettings, userPreferences, adminSettings, portraitSettings, importantMessages, newPageContent, activeConversationState, conversationMessages, groupList, activeGroup});

export default rootReducer;
